module.exports = __webpack_public_path__ + "pc-top-assets/img/logo-second-white.ece6f79d.svg";